// 管理者更新APIに送信してよい編集項目だけを組み立てる。
export const buildAdminUserUpdatePayload = (adminUser, formData) => {
  const inputCompanyId = formData.companyId;
  const hasInputCompanyId =
    inputCompanyId != null &&
    (typeof inputCompanyId !== "string" || inputCompanyId.trim() !== "");
  const companyId = hasInputCompanyId ? inputCompanyId : adminUser?.companyId;

  return {
    admin_user_id: adminUser.adminUserId,
    admin_user_name: formData.adminUserName.trim(),
    is_active: formData.isActive,
    company_id: companyId == null ? null : Number(companyId),
    role: formData.role,
  };
};
